import { ROUTE_NAME_SIGN_IN } from '@/config/routeNames';

export const ACCOUNT_RECOVERY_FORM = 'account-recovery-form';
export const SET_PASSWORD_FORM = 'set-password-form';
export const GRID_CONTAINER = 'login-page-grid-container';
export const LOGIN_FORM = 'login-form';
export const FIRST_CONNECTION_CONTENT_CARD = 'first-connection-card';
export const FIRST_CONNECTION_BUTTON = 'first-connection-button';
export const SIGNIN_PAGE = ROUTE_NAME_SIGN_IN;

export const statusBoxes = {
  CREDENTIAL_MISMATCH: 'status-box-credential-mismatch',
  USER_EXISTS: 'status-box-user-exists',
  SET_PASSWORD: 'set-password',
  INVALID_LINK: 'invalid-link',
};

export const PASSWORD_LOST_LINK = 'password-lost-link';
